
import axios from 'axios'
import join from 'url-join'

// dev
// export const baseURL = "http://192.168.205.56:4008/api/v1"
// export const imageURL = "http://192.168.205.56:4008"

export const baseURL = process.env.NODE_ENV == "production" ? "https://apidoc.comsevencareer.com/api/v1/" : "http://localhost:4008/api/v1"
export const imageURL = process.env.NODE_ENV == "production" ? "https://apidoc.comsevencareer.com" : "http://localhost:4008"

// export const baseURL = "https://apidoc.comsevencareer.com/api/v1/" 
// export const imageURL = "https://apidoc.comsevencareer.com" 

export const MobileDevice = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
);

export const NoIpadDevice = /iPhone|iPod|Android/i.test(
    navigator.userAgent
);

const isAbsoluteURLRegex = /^(?:\w+:)\/\//

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('Token')
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
}, error => {
    return Promise.reject(error);
});

axios.interceptors.request.use(async (config) => {
    if (!isAbsoluteURLRegex.test(config.url)) {
        config.url = join(baseURL, config.url)
    }
    return config
})

axios.interceptors.response.use((response) => {
    return response
}, error => {
    if (axios.isCancel(error)) {
        return Promise.reject(error)
    } else if (!error.response) {
        return Promise.reject({ status: 502, message: "Bad Gateway" })
    }
    return Promise.reject({ status: 9999, message: error })
})

export const HttpClinet = axios